import { useGetAvailableTeamsQuery } from "../Redux/service/Snag/Snag";

export const useTeams = (params = {}) => {
  const { projectId, zoneId, discipline } = params;
  
  const { data: teamsData, isFetching } = useGetAvailableTeamsQuery(
    {
      projectId,
      zoneId,
      discipline,
    },
    {
      skip: !projectId || !zoneId || !discipline, // Skip if essential parameters are missing
      refetchOnMountOrArgChange: true,
    }
  );

  const teams =
    teamsData?.data?.map((team) => ({
      id: team.id,
      name: team.name,
      users: team.users || [], // Assuming it might return users inside the team
    })) || [];

  const options = teams.map((team) => ({
    value: team.id,
    label: team.name,
    searchLabel: team.name.toLowerCase(),
  }));

  return {
    teamsData,
    teams,
    options,
    isFetching,
  };
};
